module.exports = __webpack_public_path__ + "static/media/logo-enbanca-blue.2e8f2e1a.png";